
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"25","height":"17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M23.96 2.704A3.005 3.005 0 0021.869.618c-1.872-.5-9.397-.5-9.397-.5s-7.51-.013-9.402.5A3.005 3.005 0 00.984 2.704a31.19 31.19 0 00-.523 5.81c-.003 1.94.172 3.876.523 5.784a3.018 3.018 0 002.086 2.09c1.872.5 9.402.5 9.402.5s7.506 0 9.397-.5a3.018 3.018 0 002.09-2.09c.345-1.907.513-3.845.501-5.783a31.427 31.427 0 00-.5-5.81zm-13.891 9.402V4.908l6.263 3.607-6.263 3.591z","fill":"#ABAFB5"}})])
          )
        }
      }
    